
























import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { Component } from "vue-property-decorator";
import ReportImageUpload from "./ReportImageUpload.vue";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { ReportImageType } from "@/models/Report/ReportImageType";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { ReportModule } from "@/store/modules/report.store";
import { AssetEnum } from "@/lib/AssetRepository";
import { $t } from "@/lib/utility/t";

@Component({
  components: {
    LayoutReportStep,
    ReportImageUpload
  }
})
export default class ReportCompletionImage extends ReportStepMixin implements IReportStep {
  asset = AssetEnum.carFrontRightOutline;
  example = AssetEnum.carFrontLeft;

  header: IReportHeaderData = {
    title: "report.completion.title",
    description: "report.completion.description"
  };

  instruction: IReportInstructionData = {
    title: $t("report.completion.instruction.title"),
    text: $t("report.completion.instruction.description"),
    pictures: [AssetEnum.overview],
    example: AssetEnum.overview,
    display: true
  };

  screen = ReportScreenEnum.COMPLETION;

  valid = false;

  get isDone() {
    return this.files.length > 0;
  }

  get type() {
    return ReportImageType.completion;
  }

  get files(): IImageUploaded[] {
    return ReportModule.overviews.filter(image => image.type === this.type);
  }
}
